import useIsContentForceCentered from '@hooks/useIsContentForceCentered'
import {
  desktopCenteredContentCSS,
  desktopCSS,
  desktopLeftAlignedCSS,
  tabletCSS,
} from '@measures/responsive'
import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface WrapAllProps {
  isArticle: boolean
  isError: boolean
  children?: ReactNode
}

type StyledWrapAllProps = Pick<WrapAllProps, 'isArticle' | 'isError'> & {
  isContentForceCentered: boolean
}

const StyledWrapAll = styled.div<StyledWrapAllProps>`
  ${({
    theme: {
      colors: { white },
    },
    isArticle,
    isError,
    isContentForceCentered,
  }) => css`
    grid-column: 1;
    background-color: ${white};
    width: 100%;
    box-sizing: border-box;
    position: relative;

    ${!isError &&
    css`
      overflow: hidden;
    `}
    ${!isArticle &&
    !isError &&
    css`
      ${desktopCSS(css`
        padding: 0 20px;
      `)}

      ${tabletCSS(css`
        padding: 0 52px;
      `)}
    `}

    ${desktopCenteredContentCSS(css`
      ${!isError &&
      css`
        grid-column: 2;
      `}
    `)}

    ${desktopLeftAlignedCSS(css`
      ${isContentForceCentered &&
      css`
        grid-column: 2;
      `}
    `)}

    ${tabletCSS(
      css`
        grid-column: 1;
      `
    )}
  `}
`

const WrapAll: FunctionComponent<WrapAllProps> = ({
  isArticle,
  isError,
  children,
}) => {
  const isContentForceCentered = useIsContentForceCentered()
  return (
    <StyledWrapAll
      isArticle={isArticle}
      isError={isError}
      isContentForceCentered={isContentForceCentered}>
      {children}
    </StyledWrapAll>
  )
}

export default WrapAll
